import { createSlice } from '@reduxjs/toolkit'
import {
  fetchWaterTestKitResultsAsync,
  fetchWaterTestKitResultsAsyncBuilder,
  fetchWaterTestKitResultsByUserAsync,
  fetchWaterTestKitResultsByUserAsyncBuilder,
} from './AsyncRequests'
import { WaterTestStripResultDocument } from '../../types'



interface WaterTestKitResultsState {
  loading: boolean
  error: string | null
  data: Partial<WaterTestStripResultDocument>[]
}

const TestResultsInitialState: WaterTestKitResultsState = {
  loading: false,
  error: null,
  data: [],
}

const waterTestKitResultsSlice = createSlice({
  name: 'waterTestKitResults',
  initialState: TestResultsInitialState,
  reducers: {},
  extraReducers: (builder) => {
    fetchWaterTestKitResultsAsyncBuilder(builder)
    fetchWaterTestKitResultsByUserAsyncBuilder(builder)
  },
})

export const WaterTestKitResultsActions = {
  ...waterTestKitResultsSlice.actions,
  fetchWaterTestKitResultsAsync,
  fetchWaterTestKitResultsByUserAsync,
}

export const WaterTestKitResultsReducer = waterTestKitResultsSlice.reducer
